<template>
  <div
    class="group/product-card relative transform-gpu overflow-hidden z-10 h-full"
  >
    <div
      class="relative overflow-hidden"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <div
        class="aspect-h-[450] aspect-w-[360] w-full overflow-hidden bg-white"
        :style="{
          filter: `brightness(${imageBrightnessFilter}%)`,
          backgroundColor: imageBackgroundColor?.hexa || 'transparent',
        }"
      >
        <CommonProductCardImages
          class="block h-full w-full"
          :to="productLink"
          :is-hover="showImageHover"
          :images="productImages"
          :product="product"
          @click="setGaSelectItemEvent"
        />
      </div>
      <div
        class="pointer-events-none absolute left-2.5 top-2.5 flex max-h-full flex-col flex-wrap gap-2"
      >
        <UiChip
          v-if="product.sale"
          :text="$t('sale')"
          variant="tile"
          class="h-6 py-0 font-light"
        />
        <UiChip
          v-if="product.bestseller"
          class="h-6 py-0 font-light"
          variant="tile"
          :text="$t('bestSeller')"
        />
        <template v-if="product.badges">
          <UiChip
            v-for="(badge, idx) in product.badges"
            :key="idx"
            variant="tile"
            class="h-6 py-0 font-light"
            :text="badge.title"
          />
        </template>
      </div>
      <!--      <UiButton-->
      <!--        v-if="product.default_sku"-->
      <!--        class="absolute right-2 top-2 rounded-full bg-white text-primary"-->
      <!--        variant="clear"-->
      <!--        variant-type="icon"-->
      <!--        size="xs"-->
      <!--        text="xs"-->
      <!--        :aria-label="$t('addToWishlist')"-->
      <!--        @click="-->
      <!--          updateWishlist({-->
      <!--            sku: product.default_sku,-->
      <!--            images: [-->
      <!--              product.variant_plp_image?.image?.url ||-->
      <!--                product.images?.[0]?.url ||-->
      <!--                '',-->
      <!--            ],-->
      <!--            cost: product.sale && discountValue ? discountValue : productPrice,-->
      <!--            slug: product.slug,-->
      <!--            configuration_id: product.default_sku,-->
      <!--            engraving: {},-->
      <!--            materials: product.materials,-->
      <!--            material_categories: product.material_categories,-->
      <!--            material_categories_plp_hover_ids:-->
      <!--              product.material_categories_plp_hover_ids,-->
      <!--            translations: product.translations as ProductData['translations'],-->
      <!--            active_configurations_count: product.active_configurations_count,-->
      <!--            min_cost: product.min_cost,-->
      <!--            product_id: (product as CartItem).product_id || product.id,-->
      <!--            collection_ids: product.collections_ids || [],-->
      <!--            vendor_model: product.vendor_model || '',-->
      <!--            start_at_cost: productStartAtPrice,-->
      <!--          } as WishListData);-->
      <!--          setGaSelectItemEvent();-->
      <!--        "-->
      <!--      >-->
      <!--        <ClientOnly>-->
      <!--          <UiIcon-->
      <!--            name="heart"-->
      <!--            class="size-3.5"-->
      <!--            :class="[-->
      <!--              inWishlist({-->
      <!--                sku: product.default_sku,-->
      <!--                engraving: {},-->
      <!--              } as WishListData)-->
      <!--                ? 'fill-primary'-->
      <!--                : '',-->
      <!--            ]"-->
      <!--            aria-hidden="true"-->
      <!--          />-->
      <!--        </ClientOnly>-->
      <!--      </UiButton>-->
      <div
        class="absolute left-0 bottom-0 bg-white/80 px-2 max-w-full transition-transform duration-300 ease-out"
        :class="{ 'translate-y-full': !isHover }"
      >
        <ProductMaterialIconView
          v-if="
            stoneTypeMaterialCategory && isStoneTypeMaterialCategorySkuEnabled
          "
          hide-label
          :block="stoneTypeMaterialCategory"
          :selected-item="stoneTypeSelectedItem"
          title=""
          @filter="handleFilter"
          class="!py-1.5"
        >
        </ProductMaterialIconView>
      </div>
    </div>
    <div
      class="relative space-y-2 px-2 pt-4 bg-primary"
      :style="{
        textAlign: cardContentPosition === 'center' ? 'center' : 'left',
      }"
    >
      <NuxtLink
        :to="productLink"
        class="block text-sm font-bold uppercase text-white"
        @click="setGaSelectItemEvent"
      >
        {{ productTitlePlp }}
      </NuxtLink>
      <template v-for="block in metalMaterialCategory" :key="block?.id">
        <SharedProductMaterials
          v-if="block?.materials?.length >= 1"
          :product="product"
          :data="block"
          @filter="onFilterClick"
        />
      </template>
      <p class="space-x-1 text-xs font-normal text-white">
        <!--        <span v-if="product.sale" class="text-error inline-block">-->
        <!--          {{ $n(discountValue, "currency") }}-->
        <!--          ({{ product.sale_value }}% OFF)-->
        <!--        </span>-->
        <!--        <span-->
        <!--          class="inline-block"-->
        <!--          :class="[product.sale ? 'line-through' : '']"-->
        <!--        >-->
        <!--          {{ $n(productPrice, "currency") }}-->
        <!--        </span>-->
        <template v-if="product?.active_configurations_count">
          <template
            v-if="
              productConfigurationPrice &&
              !isConfigurationInventoryOutOfStockPlp
            "
          >
            <span class="space-x-0.5 inline-block">
              <span v-if="productStartAtPrice">
                {{ $n(productStartAtPrice, "currency") }}
              </span>
              <span>
                {{ $n(productConfigurationPrice, "currency") }}
              </span>
            </span>
          </template>
          <span v-else class="lowercase inline-block">
            {{ $t("outOfStock") }}
          </span>
        </template>
        <span
          v-else-if="isConfigurationOutOfStockPlp"
          class="lowercase inline-block"
        >
          {{ $t("outOfStock") }}
        </span>
        <template v-else>
          <span
            v-if="productStartAtPrice"
            class="line-through mr-1 inline-block"
          >
            {{ $n(productStartAtPrice, "currency") }}
          </span>
          <span class="inline-block">
            {{ $n(productConfigurationPrice, "currency") }}
          </span>
        </template>
        <span
          v-if="
            isStoneTypeMaterialCategorySkuEnabled &&
            stoneTypeSelectedItem &&
            isHover
          "
          class="ui-text-xxs italic"
        >
          — {{ stoneTypeSelectedItem.currentTranslation?.title }}
        </span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  CartItem,
  CatalogData,
  ColorPickerData,
  ProductData,
  MaterialData,
  Material,
} from "ecom-types";
import { sizesSlugs, propertiesGroupSlugs } from "@/configs";
import type { WishListData } from "~/composables/_useWishlist";

const props = withDefaults(
  defineProps<{
    hover?: boolean;
    imageBrightnessFilter?: string;
    cardContentPosition?: string;
    product: CatalogData;
    plpType?: string;
    extractSetting?: boolean;
    productIndex: number;
    statisticItemListName?: string;
    imageBackgroundColor?: ColorPickerData;
  }>(),
  {
    imageBrightnessFilter: "100",
    cardContentPosition: "left",
    productIndex: 0,
    statisticItemListName: "",
  },
);

const currentProduct = ref<CatalogData>(props.product);
const fallbackConfiguration = props.product?.variant_plp_image
  ? JSON.parse(JSON.stringify(props.product.variant_plp_image))
  : null;
const fallbackSelectedConfig = props.product?.selected_config
  ? JSON.parse(JSON.stringify(props.product.selected_config))
  : null;

const {
  productMaterials,
  productLink,
  productTitlePlp,
  isConfigurationInventoryOutOfStockPlp,
  isConfigurationOutOfStockPlp,
  productStartAtPrice,
  productInfo,
  configurationInfo,
} = useProduct(props.product, sizesSlugs);

const {
  currentSku,
  result,
  additionalOptions,
  filteredMaterialsByCategories,
  setResultData,
  onFilterClick,
  onOptionsFilterClick,
} = useProductFilter(currentProduct, sizesSlugs);

setResultData();

const { mdAndDown } = useAppBreakpoints();
const { openSystemDialog } = useSystemDialogs();
const { t } = useI18n();
//
// const { addToCart } = useCart();
//
const { selectItemEvent } = useEvents();
const { $api } = useNuxtApp();
//
// const { fbAddToCartEvent } = useFacebookPixelEvents();
//
// const pending = ref(false);
const isHover = ref<boolean>(false);
const showImageHover = ref<boolean>(false);

const productImages = computed(() => {
  const productImages = getProductImages(props.product);
  if (productImages?.length > 2) {
    productImages.length = 2;
  }
  return productImages;
});

const metalMaterialCategory = computed(() => {
  return productMaterials.value?.filter(
    (el) => el?.slug === propertiesGroupSlugs.metal,
  );
});

const productConfigurationPrice = computed(() => {
  const currentConfiguration =
    props.product?.variant_plp_image || props.product?.default_config;
  return Number(currentConfiguration?.cost || 0);
});

const stoneTypeMaterialCategory = computed(() => {
  return (
    filteredMaterialsByCategories.value.find(
      (el) => el?.slug === propertiesGroupSlugs.stoneType,
    ) || null
  );
});

const isStoneTypeMaterialCategorySkuEnabled = computed(() => {
  if (!stoneTypeMaterialCategory.value) return false;
  return !!result.value?.[stoneTypeMaterialCategory.value.slug];
});

const stoneTypeSelectedItem = computed<MaterialData | null>(() => {
  if (!stoneTypeMaterialCategory.value) return null;

  return isStoneTypeMaterialCategorySkuEnabled.value
    ? (result.value[stoneTypeMaterialCategory.value.slug] as MaterialData)
    : (additionalOptions.value?.[
        stoneTypeMaterialCategory.value.slug
      ] as MaterialData);
});

async function updateConfiguration() {
  const { data, error } = await useAsyncCachedData(currentSku.value, () => {
    return $api.products.getConfiguration(currentSku.value);
  });
  if (error.value) {
    openSystemDialog({
      type: "alert",
      title: `${t("error")}!`,
      text: error.value.data?.errors?.[0]?.message || "Server error",
    });
    return;
  }
  if (!data?.value?.data) return;
  configurationInfo.value = data.value.data;
  const foundConfigurationImage = configurationInfo.value.medias?.find(
    (image) => image.position === "PLP",
  );
  if (!productInfo.value) {
    productInfo.value = currentProduct.value;
  }
  productInfo.value.variant_plp_image = {
    ...configurationInfo.value,
    image: foundConfigurationImage?.file,
    sku: configurationInfo.value.configuration_id,
  };
  
  productInfo.value.selected_config = {
    ...configurationInfo.value,
    image: foundConfigurationImage?.file,
    configuration_id: configurationInfo.value.configuration_id,
  };
  showImageHover.value = false;
}

function handleFilter(data) {
  if (
    stoneTypeMaterialCategory.value?.slug &&
    result.value?.[stoneTypeMaterialCategory.value.slug]
  ) {
    onFilterClick(data);
  } else {
    onOptionsFilterClick(data);
  }
}

watch(() => currentSku.value, updateConfiguration);

// async function onAddToCart(product: CatalogData) {
//   pending.value = true;
//   try {
//     let imageIdListIds = [] as number[];
//     let image = null;
//     if (!productImages.value[0].id && !isEmpty(productImages.value)) {
//       image = await mergeImages([{ src: productImages.value[0]?.url }]);
//     } else {
//       imageIdListIds = [productImages.value[0].id];
//     }
//
//     await addToCart({
//       configuration_id: productSKU.value,
//       vendor_model: product.vendor_model,
//       images: image ? [image] : [],
//       images_ids: imageIdListIds,
//     });
//     gaAddToCartEvent(product, product?.default_config);
//     fbAddToCartEvent(product, product?.default_config);
//     setGaSelectItemEvent();
//   } catch (error) {
//     if (error instanceof ImageMergeError) {
//       openSystemDialog({
//         type: "alert",
//         title: `${t("error")}!`,
//         text: `${t("failedLoadImage")}!`,
//       });
//     }
//   } finally {
//     pending.value = false;
//   }
// }

function onMouseEnter() {
  if (mdAndDown.value) return;
  isHover.value = true;
  showImageHover.value = true;
}

function onMouseLeave() {
  isHover.value = false;
  showImageHover.value = false;
}

function setGaSelectItemEvent() {
  selectItemEvent(props.product, {
    index: props.productIndex,
    item_list_name: props.statisticItemListName,
  });
}

onBeforeUnmount(() => {
  if (productInfo.value) {
    productInfo.value.variant_plp_image = fallbackConfiguration
      ? JSON.parse(JSON.stringify(fallbackConfiguration))
      : null;
    productInfo.value.selected_config = fallbackSelectedConfig
      ? JSON.parse(JSON.stringify(fallbackSelectedConfig))
      : null;
  }
});
</script>
